export default __webpack_public_path__ + "static/media/angularlove.13c584f0.png";